import React from 'react';
import CustomImage from '../../components/custom-image';
import SectionTitle from '../../components/section-title';
import PageLayout from '../../layouts/pagelayout';
import Accordion from '../../components/accordion';
import WellInvested from '../../content/investment-case';
import OperationalExcellence from '../../content/investment-case/operational-excellence';
import StrongFinancial from '../../content/investment-case/strong-financial';
import ProvenTrackRecord from '../../content/investment-case/proven-track-record';
import BreadCrumb from '../../components/breadcrumb';
import ScrollPositionAnimation from '../../components/scrollpositionanimation';

const InvestmentCase = () => {
  const sampleData = {
    accordion: [
      { id: 1, title: 'Well-invested assets driving free cash flow growth', source: () => <WellInvested /> },
      {
        id: 2,
        title: 'Operational excellence and technology driving efficiency and sustainability',
        source: () => <OperationalExcellence />,
      },
      { id: 3, title: 'Strong financial profile ', source: () => <StrongFinancial /> },
      { id: 4, title: 'Proven track record ', source: () => <ProvenTrackRecord /> },
    ],
  };
  return (
    <PageLayout pageTitle="Vedanta - Investment Case" pageLink="/overview/investment-case">
      <div className="investment-case-page">
        <div className="container-1440">
          <BreadCrumb />
          <div className="container">
            <div className="container-inner">
              <ScrollPositionAnimation targetElement1="anim-1" targetElement2="anim-2">
                <div className="content-row">
                  <div className="column-50">
                    <div className="left-content">
                      <div className="left-to-right anim-1">
                        <div className="desktop-img">
                          <CustomImage className="custom-image" imageName="investment-case.png" alt="Investment Case" />
                        </div>
                        <div className="mobile-img">
                          <CustomImage
                            className="custom-image"
                            imageName="investment-case-mobile.png"
                            alt="Investment Case"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="column-50">
                    <div className="bottom-to-top anim-2">
                      <div className="right-content">
                        <div className="header-title">
                          <SectionTitle
                            label="INVESTMENT CASE"
                            lighttext="Well-positioned"
                            boldtext="FOR THE FUTURE"
                            iconimage="invest-icon.png"
                            alt="Investment Case"
                          />
                        </div>
                        <div className="description">
                          <div className="sub-text">
                            <p>
                              Natural resources represent a critical growth engine for the economy. As India’s only
                              diversified natural resources Company, we are very well positioned to make a significant
                              contribution to the nation’s prosperity. Our investment case is focused on delivering
                              sustainable, long-term returns to our shareholders and creating value for our larger
                              stakeholder fraternity.
                            </p>
                          </div>
                          <h3>Large, low-cost and diversified asset base with an attractive commodity mix</h3>
                          <p>
                            Vedanta’s large-scale, diversified asset portfolio, with an attractive cost position in many
                            of its core businesses, positions us to deliver strong margins and free cash flows through
                            the commodity cycle. We have an attractive commodity mix, with strong fundamentals and
                            leading demand growth and focus on base metals and oil. The commodity markets strengthened
                            in the second half of this financial year, driven by improved demand factors and continuing
                            supplyside constraints, benefiting global commodity prices, particularly Vedanta’s core
                            commodities, including zinc, aluminium and oil & gas.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollPositionAnimation>
              <div className="mid-content">
                <ScrollPositionAnimation targetElement2="anim-3">
                  <div className="bottom-to-top anim-3">
                    <div className="bar-chart">
                      <div className="content-row">
                        <div className="column">
                          <div className="desktop-img">
                            <CustomImage imageName="investment-case-bar-chart.png" alt="Investment Case Bar Chart" />
                          </div>
                          <div className="mobile-img">
                            <CustomImage
                              imageName="investment-case-bar-chart-mobile.png"
                              alt="Investment Case Bar Chart"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="ideally-position-section">
                      <h3>Ideally positioned to capitalise on India’s growth potential</h3>
                      <div className="content-row">
                        <div className="column-75">
                          <p>
                            India is our core market and it has a huge growth potential, given that the current per
                            capita metal consumption is significantly lower than the global average. The COVID-19
                            pandemic is inflicting significant human costs in India and the world. Protecting lives and
                            allowing healthcare systems to cope have required isolation, lockdowns, and widespread
                            closures to flatten the curve in India as in other parts of the world. Against this bleak
                            backdrop, IMF predicts that the Indian economy is estimated to have grown by 1.9% in the
                            financial year. However, the economy’s long-term potential remains robust, as it is likely
                            to rebound to 7.4% in FY2021, provided the outbreak is contained and there is no recurrence.
                            Once the economy reboots and the crisis blows over, strong liquidity in the economy and
                            government impetus in infrastructure building, housing and industrialisation will generate
                            demand for natural resources. The country’s high resource import bill offers significant
                            opportunities for a diversified player like us.{' '}
                          </p>
                          <p>
                            The government has lately announced various policy measures to support the commodity sector,
                            which augurs well for our operations.{' '}
                          </p>
                          <ul className="lists green-bullets">
                            <p>We are uniquely positioned to benefit from India’s growth due to:</p>
                            <li>A diversified portfolio of established operations in India;</li>
                            <li>
                              A strong market position as India’s largest base metals producer and largest private
                              sector oil producer
                            </li>
                            <li>
                              An operating team with an extensive track record of executing projects and achieving
                              growth
                            </li>
                          </ul>
                        </div>
                        <div className="column-25">
                          <div className="india-growth-potential">
                            <p>India’s Growth Potential</p>
                            <div className="desktop-img">
                              <CustomImage imageName="india-growth-potential.png" alt="India Growth Potential" />
                            </div>
                            <div className="mobile-img">
                              <CustomImage
                                imageName="india-growth-potential-mobile.png"
                                alt="Investment Case Bar Chart"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ScrollPositionAnimation>
                <div className="commodity-demand-potential">
                  <ScrollPositionAnimation targetElement1="anim-4">
                    <div className="right-to-left anim-4">
                      <p>Commodity Demand Potential 2020</p>
                      <div className="desktop-img">
                        <div className="content-row">
                          <div className="column">
                            <CustomImage
                              imageName="commodity-demand-potential.png"
                              alt="commodity Demand Potential 2020"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mobile-img">
                        <div className="content-row">
                          <div className="column-50">
                            <CustomImage
                              imageName="commodity-demand-potential-one.png"
                              alt="commodity Demand Potential 2020"
                            />
                          </div>
                          <div className="column-50">
                            <CustomImage
                              imageName="commodity-demand-potential-two.png"
                              alt="commodity Demand Potential 2020"
                            />
                          </div>
                        </div>
                        <div className="column"></div>
                      </div>
                    </div>
                  </ScrollPositionAnimation>
                </div>

                <div className="content-accordian">
                  <ScrollPositionAnimation targetElement2="anim-5">
                    <div className="content-row">
                      <div className="column-75">
                        <div className="accordion-content">
                          <div className="bottom-to-top anim-5">
                            <Accordion data={sampleData.accordion} />
                          </div>
                        </div>
                      </div>
                      <div className="column-25"></div>
                    </div>
                  </ScrollPositionAnimation>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-banner"></div>
      </div>
    </PageLayout>
  );
};

export default InvestmentCase;
